import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../components/Logo";
import { Box, useMediaQuery, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import PhoneButton from "../components/PhoneButton";
import { ReactComponent as Phone } from "../data/svg/phone.svg";
import LinkLogo from "../components/LinkLogo";
import {
  headerBox,
  menuBox,
  activeMenuBox,
  buttonBox,
  mobileMenuBox,
  mobileMenuItem,
  slideDown,
  slideUp,
  backdropStyle,
} from "../styles/styles";
import { isTabWidth, phoneNumber, menuItems } from "../data/database";
import { customColour } from "../data/colour";

const Header = ({
  LogoSvg,
  LinkLogoSvg,
  // menuItems,
  linkLogo,
  width = "100vw",
}) => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isTab = useMediaQuery(isTabWidth);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      {/* Header Container */}
      <Box sx={headerBox}>
        <Box
          sx={{
            width: width,
            margin: "auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "relative",
            paddingLeft: isTab ? "1rem" : "3rem",
            paddingRight: isTab ? "1rem" : "3rem",
          }}
        >
          {/* Logo Section */}
          <Logo LogoSvg={LogoSvg} height={isTab ? 30 : 50} />

          {/* Menu Items or Hamburger Icon */}
          <Box>
            {isTab ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconButton
                  onClick={handleMenuToggle}
                  sx={{ color: customColour.lightBlue }}
                >
                  <MenuIcon />
                </IconButton>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 0",
                }}
              >
                {/* Render Menu Items */}
                {menuItems.map((item, index) => (
                  <React.Fragment key={index}>
                    <Box
                      component={Link}
                      to={item.path}
                      sx={{
                        ...menuBox,
                        textDecoration: "none",
                        margin: "0 20px",
                        color:
                          location.pathname === item.path
                            ? customColour.black
                            : customColour.grey,
                        fontWeight:
                          location.pathname === item.path ? "600" : "100",
                      }}
                    >
                      <Box
                        sx={{
                          ...buttonBox,
                          whiteSpace: "nowrap",
                          fontSize: "1rem",
                          fontWeight: "inherit",
                        }}
                      >
                        {item.label}
                      </Box>
                    </Box>
                    {index < menuItems.length - 1 && (
                      <Box
                        sx={{
                          margin: "0 10px",
                          color: customColour.black,
                          fontSize: "1rem",
                          fontWeight: "200",
                        }}
                      >
                        |
                      </Box>
                    )}
                  </React.Fragment>
                ))}
              </Box>
            )}
          </Box>

          {/* Link Logo */}
          <LinkLogo
            linkLogo={linkLogo}
            LinkLogoSvg={LinkLogoSvg}
            width={isTab ? 25 : 40}
          />
        </Box>
      </Box>

      {/* Backdrop Overlay */}
      {isMenuOpen && (
        <Box
          sx={backdropStyle}
          onClick={handleCloseMenu} // Close menu when backdrop is clicked
        />
      )}

      {/* Mobile Menu Dropdown */}
      <Box
        sx={{
          ...mobileMenuBox,
          ...(isMenuOpen ? slideDown : slideUp), // Apply styles conditionally based on menu state
        }}
      >
        {menuItems.map((item, index) => (
          <Box
            key={index}
            component={Link}
            to={item.path}
            onClick={() => setIsMenuOpen(false)} // Close menu on item click
            className="menu-link"
            sx={{
              ...mobileMenuItem,
              ...(location.pathname === item.path && activeMenuBox),
            }}
          >
            <Box sx={{ fontSize: "0.9rem", padding: "0.9rem 0" }}>
              {item.label}
            </Box>
          </Box>
        ))}
      </Box>

      {/* Fixed Phone Button */}
      {isTab && (
        <PhoneButton
          phoneNumber={phoneNumber}
          LogoSvg={Phone}
          logoHeight={50}
          logoWidth={50}
          logoColor={customColour.green}
          sx={{
            position: "fixed",
            bottom: "1rem",
            right: "1rem",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
          }}
        />
      )}
    </>
  );
};

export default Header;
